export function params (data) {
  return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
}

// 空函数
export function noop () {
}

export function getCookie (name) {
  let value = '; ' + window.document.cookie;
  let parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();

  return ''
}

export function getOrCreateLocalId () {
  if (window && window.localStorage) {
    const ls = window.localStorage;
    let deviceId = ls.getItem('deviceId');
    if (deviceId) {
      return deviceId;
    } else {
      deviceId = `${(Math.random() * 1000000).toString(16)}_${new Date().getTime()}`;
      ls.setItem('deviceId', deviceId);
      return deviceId;
    }
  } else {
    return 'no_support_localStorage';
  }
};
